import IDynamicFormRow from "../../../../../../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import Styles from "../../../../../../../scss/formFields.module.scss";
import { validateEmail } from "../../../AddNewUsers/utils";
import SearchEmailInput from "./SearchEmailInput";

const SearchEmailForm = (
  t: (key: string) => string,
  isLoading?: boolean,
  userStatus?: string,
  isClear?: boolean,
  error?: string
): IDynamicFormRow[] => {
  return [
    {
      label: "checkUserStatus.form.email",
      keyName: "email",
      Component: SearchEmailInput,
      disabled: userStatus !== undefined,
      formProps: {
        userStatus: userStatus,
        isLoading: isLoading,
        isClear: isClear,
        error: error,
      },
      inputProperties: {
        placeholder: t("checkUserStatus.form.emailPlaceHolder"),
      },
      registerOptions: {
        required: true,
        validate: (email: string) => {
          return (
            validateEmail(email) || t("user_management.errors.invalidEmail")
          );
        },
      },
      gridColumnOptions: {
        formCol: 12,
      },
      className: Styles.TextBoxWithAddon,
    },
  ];
};

export default SearchEmailForm;
